/**
 * Created by shaik on 29/10/17.
 */
define(function (require) {

    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};
    var lpWebAgentStatics = require('web-agent-assets-js/lpWebAgentStatics');
    var BaseController = require('web-agent-assets-js/BaseController');

    var amsCommunicationChannel = lpWebAgentStatics.COMMUNICATION_CHANNELS.AMS;
    var EVENT_TYPES = lpTag.AMSStatics.eventTypes;
    var timersDictionary = {};

    var lpOnlinePresenceController = BaseController.extend(function lpOnlinePresenceController(options) {
        if (options) {
            this.updateInterval = options.updateInterval;
            this.model = options.model;
        }

        lpTag.WebAgent.channel.register(amsCommunicationChannel.name, amsCommunicationChannel.events.onEventNotification, this.onEventNotification.bind(this));
    });

    /////////////////////////////////// PUBLIC VARIABLES ///////////////////////////////////
    lpOnlinePresenceController.prototype.applicationType = 'onlinePresenceController';

    /////////////////////////////////// PUBLIC METHODS ///////////////////////////////////

    lpOnlinePresenceController.prototype.onEventNotification = function (data) {
        if (data && data.event && data.event.type) {
            switch (data.event.type) {
                case EVENT_TYPES.CHAT_STATE:
                    this.handleChatState(data);
                    break;
                default:
                    break;
            }
        }
    };

    lpOnlinePresenceController.prototype.handleChatState = function (data) {
        var conversationId, userId, state;

        if (data) {
            conversationId = _getConversationId(data);
            userId = data.originatorId;
            state = data.event && data.event.chatState;
        }
        if (conversationId && userId && state) {
            if (_isOriginatorConsumer.call(this, data)) {
                switch (state.toLowerCase()) {
                    case lpTag.AMSStatics.chatStates.COMPOSING: //typing event
                    case lpTag.AMSStatics.chatStates.ACTIVE: //online event
                        _setOnline.call(this, conversationId);
                        _setTimer.call(this, conversationId);
                        break;
                    default:
                        break;
                }
            }
        }
    };

    function _setOnline(conversationId) {
        this.model.set('chats.' + conversationId + '.visitorInfo.lastPresenceTime', Date.now() - (Date.now() % 10000));
        this.model.set('chats.' + conversationId + '.visitorInfo.isOnlinePresence', true);
    }

    function _setTimer(conversationId) {
        //stop timer if already running
        if(timersDictionary[conversationId]) {
            clearTimeout(timersDictionary[conversationId]);
        }
        timersDictionary[conversationId] = setTimeout(_setOffline.bind(this, conversationId), this.updateInterval * 1000 );
    }

    function _setOffline(conversationId) {
        this.model.set('chats.' + conversationId + '.visitorInfo.isOnlinePresence', false);
        delete timersDictionary[conversationId];
    }

    function _getConversationId(messageData) {
        return messageData && messageData.dialogId;
    }

    function _isOriginatorConsumer(messageData) {
        var convId = _getConversationId(messageData);
        var consumerId = this.model.get('chats.' + convId + '.visitorInfo.visitorId');
        return messageData.originatorId === consumerId;
    }
    return lpOnlinePresenceController;
});
